
import React, { Component, Fragment, useEffect, useState } from "react";
import {
	Card,
	CardBody,
	CardTitle,
	Row,
	Col,

} from 'reactstrap';
import PerfectScrollbar from 'react-perfect-scrollbar';
import { authenticationService } from '../../jwt/_services';

import {
	ComponentStatisticsView,
	TopRepairReasons
} from '../../components/component-statistics/';

import {
	TopComponents,
	TopComponentsByBatch
} from '../../components/dashboard/';

class ComponentStatistics extends React.Component {

	intervalID = 0;

	constructor(props) {
    super(props);

		const currentUser = authenticationService.currentUserValue;

    this.state = {
			currentUser,
	  };

		//this.handleMessage = this.handleMessage.bind(this);
		//this.testCall = this.testCall.bind(this);

  }

	componentDidMount() {

		//this.getData();
	}

	componentWillUnmount() {

	}

	getData = async () => {

		var url = "https://9xnwyna9id.execute-api.us-west-2.amazonaws.com/v1/all-devices";

		const response = await fetch(url, {
			method: 'GET',
			headers: {
				Authorization: this.state.currentUser.jwtToken
			},
		});

		const body = await response.json();
		console.log("all devices: " + JSON.stringify(body));

		if (body.status == 'Success') {
			//this.setState({ devices: body.results });
		} else {
      //ADD ERROR MESSAGE
    }

    //this.setState({ devicesLoaded: true });
	};


	render() {
		return (
			<div>
				<Row className="mb-2">
					<Col md="12">
						<h1 style={{color:'#737782'}}>Component Statistics</h1>
					</Col>
				</Row>
				<Row>
					<Col md="12">
						<ComponentStatisticsView />
					</Col>
				</Row>
				<Row>
					<Col md="6">
						{
							<TopRepairReasons productName="Gemini" />
						}
					</Col>
					<Col md="6">
						{
							<TopRepairReasons productName="EVO" />
						}
					</Col>
				</Row>
				<Row>
					<Col md="6">
						{
							<TopComponents productName="Gemini" />
						}
					</Col>
					<Col md="6">
						{
							<TopComponents productName="EVO" />
						}
					</Col>
				</Row>
				{
					// <Row>
					// 	<Col md="12">
					// 		{
					// 			<TopComponentsByBatch />
					// 		}
					// 	</Col>
					// </Row>
				}
			</div>
		);
	}
}

export default ComponentStatistics;
